import { Flex, Heading, Text } from '@chakra-ui/react'
import { FC } from 'react'
import Loader from 'react-loader-spinner'

import { ILayoutMessageProps } from '@base/@types/components/Layout/Message'

const LayoutLoader: FC<ILayoutMessageProps> = ({ title, message, type }) => {
  return (
    <Flex h="50vh" flexDir="column" alignItems="center" justifyContent="center">
      <Loader
        type="Grid"
        color="rgb(254, 205, 4)"
        height={type === 'chart' || type === 'rupture' ? 50 : 60}
        width={type === 'chart' || type === 'rupture' ? 50 : 60}
      />
      <Heading
        size={type === 'chart' || type === 'rupture' ? 'md' : 'lg'}
        mb={2}
        mt={12}
      >
        {title}
      </Heading>
      <Text color="gray.500">{message}</Text>
    </Flex>
  )
}

export default LayoutLoader
